 
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ServicesState } from '../../actions/types/services/GetServiceTypes';

/**
 * Initial Dashboard state in store
 */
export const initialState: ServicesState = {
  isLoading: false,
  isTrackerLoading: true,
  iseventDetailsLoading: true,
  success: false,
  errorMessage: '',
  ServicesDetails: []
};

/**
 * get metric summary Slice to get metric
 */
export const getServicesSlice = createSlice({
  name: 'getMetricsSummary',
  initialState,
  reducers: {
    getServicesStarted: (state) => {
      state.isLoading = true;
    },

    getServicesSuccess: (state, action: PayloadAction<any>) => {
      state.isLoading = false;
      state.success = true;
      state.errorMessage = '';
      state.ServicesDetails = action.payload;
    },

    getServicesFail: (state, action: PayloadAction<string>) => {
      state.isLoading = false;
      state.success = false;
      state.errorMessage = action.payload;
      state.ServicesDetails =
        initialState.ServicesDetails;
    },

    clearServices: (state) => {
      state.isLoading = false;
      state.success = false;
      state.errorMessage = '';
      state.ServicesDetails =
        initialState.ServicesDetails;
    }
  }
});

export const {
  getServicesStarted,
  getServicesSuccess,
  getServicesFail,
  clearServices
} = getServicesSlice.actions;
export default getServicesSlice.reducer;
